import { createConsumer } from "@rails/actioncable";

// const APP_CABLE_URL = "wss://backend.bcw.club/cable";
// const APP_CABLE_URL = "http://192.168.18.128:3000/cable";
const APP_CABLE_URL = process.env.REACT_APP_BACKEND_WS_LINK;
const consumer = createConsumer(APP_CABLE_URL);
export default consumer;
